<template>
	<div class="passkeyRecord">
		<div class="passkeyTitlebar">
			<img v-if="passkey.ProviderIcon" :class="{ passkeyIcon: true, lowResIcon: iconIsLowRes }" :src="passkey.ProviderIcon" alt="" @load="CheckIconResolution" />
			<img v-else class="passkeyIcon" :src="appPath + 'Images/key.png'" alt="" role="presentation" />
			<div class="passkeyName">{{displayName}}</div>
			<input type="button" value="rename" @click="$emit('rename', passkey)" :disabled="disabled" :aria-label="'rename passkey ' + displayName" />
			<input type="button" value="delete" @click="$emit('delete', passkey)" :disabled="disabled" :aria-label="'delete passkey ' + displayName" />
		</div>
		<div v-if="passkey.ProviderName">Provider: {{passkey.ProviderName}}</div>
		<div class="passkeyId">Id: {{passkey.Id}}</div>
		<div>Created {{getFuzzyTimeDistance(passkey.RegDate)}}</div>
		<div>Last used {{getFuzzyTimeDistance(passkey.LastUsed)}}</div>
	</div>
</template>

<script>
	import { GetFuzzyTime } from 'appRoot/scripts/Util';

	export default {
		props:
		{
			/**
			 * PasskeyInfo from the server: Id, Name, ProviderName, ProviderIcon (data URI), RegDate, LastUsed.
			 */
			passkey: {
				type: Object,
				required: true
			},
			disabled: {
				type: Boolean,
				default: false
			}
		},
		emits: ['rename', 'delete'],
		data()
		{
			return {
				appPath: appContext.appPath,
				iconIsLowRes: false
			};
		},
		computed:
		{
			displayName()
			{
				return this.passkey.Name ? this.passkey.Name : "Unnamed passkey";
			}
		},
		methods:
		{
			/**
			 * Flags provider icons that the browser must enlarge to at least twice their size, so they are drawn with crisp square pixels instead of being blurred.
			 * Other icons keep the browser's normal smoothing: image-rendering: pixelated is not reliably limited to enlargement in every browser.
			 * SVG icons are vector images and never need it.
			 */
			CheckIconResolution(e)
			{
				let img = e.target;
				if (!img.naturalWidth || /^data:image\/svg/i.test(img.src))
				{
					this.iconIsLowRes = false;
					return;
				}
				let style = window.getComputedStyle(img);
				let contentWidth = img.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
				let devicePixels = contentWidth * (window.devicePixelRatio || 1);
				this.iconIsLowRes = devicePixels >= img.naturalWidth * 2;
			},
			getFuzzyTimeDistance(time)
			{
				if (time <= 0)
					return "Never";
				return GetFuzzyTime(Date.now() - time) + " ago (" + new Date(time).toLocaleString() + ")";
			}
		}
	}
</script>

<style scoped>
	.passkeyRecord
	{
		border: 1px solid #666666;
		border-radius: 5px;
		padding: 4px 8px;
		margin-bottom: 0.5em;
	}

	.passkeyTitlebar
	{
		display: flex;
		align-items: center;
		gap: 4px;
		margin-bottom: 2px;
	}

	.passkeyIcon
	{
		flex: 0 0 auto;
		width: 36px;
		height: 36px;
		box-sizing: border-box;
		padding: 2px;
		object-fit: contain;
	}

	.lowResIcon
	{
		image-rendering: pixelated;
	}

	.passkeyName
	{
		flex: 1 1 auto;
		font-weight: bold;
		word-break: break-word;
	}

	.passkeyId
	{
		word-break: break-all;
	}
</style>
